import { Dialog } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useService } from '~/services/service.base';
import { DialogService } from '~/services/service.dialog';

export const PrivacyPolicyDialog: FC = observer(() => {
    const dialogService = useService(DialogService);
    const { privacyPolicyDialogSrv } = dialogService;

    return (
        <Dialog open={privacyPolicyDialogSrv.open} className="hr-modal-dialog link-unity-modal">
            <div className="modal-dialog modal-dialog-centered privacy-policy">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" onClick={privacyPolicyDialogSrv.handleClose}>
                            <figure>
                                <img src="/assets/img/modal-close-btn.svg" />
                            </figure>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="modalContent">
                            <div className="unity-logo-wrap-modal">
                                <figure>
                                    <img className="unity-logo-modal" src="/assets/img/unity-logo-modal.svg" />
                                    <img
                                        className="unity-logo-modal-mobile"
                                        src="/assets/img/unity-logo-modal-mobile.svg"
                                    />
                                </figure>
                            </div>
                            <div className="privacy-policy-content">{privacyPolicyDialogSrv.documentText}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
});
